/**
 * StatusBadge — small pill displaying task status with the
 * corresponding color from the design tokens.
 *
 * Props:
 *   status — one of 'todo' | 'in_progress' | 'done' | 'overdue' | 'redo'
 *   size   — 'sm' | 'md' (default 'sm')
 */

import { TASK_STATUS_LABELS, TASK_STATUS_COLORS } from '../../data/constants.js';

const SIZE_CLASSES = {
  sm: 'text-[11px] px-2 py-0.5',
  md: 'text-xs px-2.5 py-1',
};

export default function StatusBadge({ status, size = 'sm' }) {
  const label = TASK_STATUS_LABELS[status] || status;
  const color = TASK_STATUS_COLORS[status] || '#6B7280';
  const sizeCls = SIZE_CLASSES[size] || SIZE_CLASSES.sm;

  return (
    <span
      className={`inline-flex items-center gap-1.5 rounded-full font-semibold whitespace-nowrap ${sizeCls}`}
      style={{
        // Light tint background, full color text + dot.
        // Hex with low-alpha works in modern browsers.
        backgroundColor: `${color}1A`, // ~10% alpha
        color,
      }}
    >
      <span
        className="w-1.5 h-1.5 rounded-full"
        style={{ backgroundColor: color }}
        aria-hidden="true"
      />
      {label}
    </span>
  );
}